<template>
  <a-icon
    v-bind="$attrs"
    :id="wrapperId"
    :icon="$attrs.icon || ICON.SOCIAL_SQUARE_FOLLOW_TAG"
    :disabled="!processedTag.id || inProgress"
    :is-button="!$attrs.to"
    :title="title"
    :title-on-hover="titleOnHover"
    :original="true"
    @click="onClick"
  />
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import mixins from '@/utils/mixins'
import AIcon, { ICON } from 'shared/AIcon'
import { METHOD_NAME, PENDING_ACTION } from 'enums/pending-actions'

export default {
  name: 'FollowTag',
  inheritAttrs: false,
  mixins: [
    mixins.pendingAuthActions,
    mixins.refreshDataListenersFactory({
      startRefreshHandlerByType: {
        [PENDING_ACTION.FOLLOW_TAG]: METHOD_NAME.HANDLE_START_PENDING_ACTION
      },
      endRefreshHandlerByType: {
        [PENDING_ACTION.FOLLOW_TAG]: METHOD_NAME.HANDLE_END_PENDING_ACTION
      }
    })
  ],
  components: { AIcon },
  props: {
    tag: propValidator([PROP_TYPES.OBJECT])
  },
  data() {
    return { ICON, inProgress: false, guid: this.$helper.guid() }
  },
  computed: {
    wrapperId() {
      return `${this.$options.name}-${this.guid}`
    },
    processedTag() {
      return this.$helper.processResponse(this.tag)
    },
    title() {
      const prefix = this.processedTag.isFollowed ? 'Following' : 'Follow'
      return `${prefix} ${this.processedTag.name}`
    },
    titleOnHover() {
      const prefix = this.processedTag.isFollowed ? 'Unfollow' : 'Follow'
      return `${prefix} ${this.processedTag.name}`
    }
  },
  methods: {
    onClick() {
      const actionData = {
        id: this.processedTag.id,
        newValue: !this.processedTag.isFollowed
      }
      this.$_pendingAuthActions_handleAction({
        actionType: PENDING_ACTION.FOLLOW_TAG,
        actionData,
        activatorSelector: `#${this.wrapperId}`
      })
    },
    [METHOD_NAME.HANDLE_START_PENDING_ACTION](refreshPayload) {
      if (refreshPayload.id === this.processedTag.id) {
        this.inProgress = true
      }
    },
    [METHOD_NAME.HANDLE_END_PENDING_ACTION](refreshPayload) {
      if (refreshPayload.id === this.processedTag.id) {
        this.inProgress = false
      }
    }
  }
}
</script>
